module.exports = __webpack_public_path__ + "static/media/Extreme-Sleeves_thumb.0cd49130.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/weird-wonderful/Extreme-Sleeves_thumb.jpg
// module id = 366
// module chunks = 0